import { useState, useEffect } from 'react'

const NAMES = [
  'Mariana de La Plata',
  'Carlos de Córdoba',
  'Silvia de Rosario',
  'Fernando de Mendoza',
  'Laura de Buenos Aires',
  'Patricia de Mar del Plata',
  'Esteban de Santa Fe',
  'Gabriela de Tucumán',
  'Javier de Neuquén',
  'Andrea de Salta',
]

export function usePurchasePopup() {
  const [isVisible, setIsVisible] = useState(false)
  const [purchaser, setPurchaser] = useState('')

  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerPopup()
    }, 5000)

    const triggerPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)]
      setPurchaser(randomName)
      setIsVisible(true)

      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false)
        // Schedule next popup (random between 8-15 seconds)
        const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000)
        setTimeout(triggerPopup, nextDelay)
      }, 4000)
    }

    return () => clearTimeout(initialTimeout)
  }, [])

  return { isVisible, purchaser }
}
